// title
// isActive
// isOnline
// location
// cityId
// placeId
// translations
export default [
  {
    value: 'title',
    text: 'Имя',
    type: 'string',
    description: ''
  },
  {
    value: 'isActive',
    text: 'Активен',
    width: 80,
    type: 'boolean',
    description: ''
  },
  {
    value: 'isOnline',
    text: 'Онлайн',
    width: 80,
    type: 'boolean',
    description: ''
  },
  {
    value: 'place.title',
    text: 'Место',
    type: 'string',
    description: ''
  },
  {
    value: 'city.title',
    text: 'Город',
    width: 160,
    type: 'string',
    description: ''
  },
  {
    text: 'Создано',
    value: 'createdAt',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Изменено',
    value: 'updatedAt',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Сортировка',
    value: 'sortOrder',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    align: 'end',
    width: 105,
    type: 'actions',
    sortable: false,
    description: ''
  }
]
